import { useOutletContext } from 'react-router';

export const useHeaderHeight = () =>
  useOutletContext<{ headerHeight: number }>();
